<span
  [ngbPopover]="popoverContent"
  triggers="manual"
  class="mt-2 ms-2"
  #pop="ngbPopover"
  (mouseenter)="smallScreen ? null : pop.open()"
  (mouseleave)="pop.close()"
  (click)="smallScreen ? modal.openModal() : null"
  ><svg-icon
    class="icon-info"
    [src]="'./assets/images/icons/info.svg'"
    [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
  ></svg-icon
></span>

<ng-template #popoverContent>
  <app-popover-content [popoverInfo]="popoverInfo"></app-popover-content>
</ng-template>

<app-info-modal
  #modal
  [title]="getTranslationKey(popoverInfo!.title)"
  [popoverInfo]="popoverInfo"
>
</app-info-modal>
